import { exeRequest } from '../utils/APIUtils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll: async () => exeRequest('/admin/app-banners', 'GET'),

  getById: async (id) => exeRequest(`/admin/app-banners/${id}`, 'GET'),

  create: async (data) => {
    const formData = new FormData();
    if (data.titre) formData.append('titre', data.titre);
    if (data.description) formData.append('description', data.description);
    if (data.ordre !== undefined) formData.append('ordre', data.ordre);
    formData.append('isActive', data.isActive !== false);
    if (data.image instanceof File) formData.append('image', data.image);
    return exeRequest('/admin/app-banners', 'POST', formData);
  },

  update: async (id, data) => {
    const formData = new FormData();
    if (data.titre !== undefined) formData.append('titre', data.titre);
    if (data.description !== undefined) formData.append('description', data.description);
    if (data.ordre !== undefined) formData.append('ordre', data.ordre);
    if (data.isActive !== undefined) formData.append('isActive', data.isActive);
    if (data.image instanceof File) formData.append('image', data.image);
    return exeRequest(`/admin/app-banners/${id}`, 'PUT', formData);
  },

  toggle: async (id) => exeRequest(`/admin/app-banners/${id}/toggle-active`, 'PATCH'),

  delete: async (id) => exeRequest(`/admin/app-banners/${id}`, 'DELETE'),
};
